'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _LockIcon = require('./LockIcon');

var _LockIcon2 = _interopRequireDefault(_LockIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LockIcon2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/LockIcon/index.js
// module id = 603
// module chunks = 11